import React from "react";

function CityIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 8H10C7.518 8 7 8.518 7 11V22H17V11C17 8.518 16.482 8 14 8Z"
        stroke="#424242"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M11 11.9999H13M11 14.9999H13M11 17.9999H13M21 21.9999V8.1859C21 6.9569 21 6.3429 20.701 5.8499C20.403 5.3559 19.865 5.0809 18.789 4.5319L14.447 2.3149C13.287 1.7229 13 1.9319 13 3.2299V7.7039M3 21.9999V12.9999C3 12.1729 3.173 11.9999 4 11.9999H7M22 21.9999H2"
        stroke="#424242"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CityIcon;
